type LAConfig = Record<string, any>
let loading = false
let loaded = false
export async function load51LA(config: LAConfig) {
  if (loaded || loading || !config || config.enabled !== true || !config.id) return
  loading = true
  try {
    const ready = () => { const la = (window as any).LA; return la && typeof la.init === 'function' }
    const init = () => { if (!ready() || document.querySelector('script[data-la-init="51la"]')) return; const s = document.createElement('script'); s.dataset.laInit = '51la'; s.textContent = `LA.init(${JSON.stringify({ id: config.id, ck: config.ck || '', autoTrack: config.autoTrack !== false, hashMode: config.hashMode === true, screenRecord: config.screenRecord === true })})`; document.head.appendChild(s); loaded = true }
    if (ready()) { init(); return }
    const script = (document.getElementById('LA_COLLECT') as HTMLScriptElement | null) || document.createElement('script'); script.charset = 'UTF-8'; script.id = 'LA_COLLECT'; script.async = true; script.src = 'https://sdk.51.la/js-sdk-pro.min.js'; script.addEventListener('load', init, { once: true }); if (!script.parentNode) document.head.appendChild(script)
  } finally { loading = false }
}
